import React, { useState } from 'react';
import { FiHome, FiUsers, FiTool, FiArrowUp, FiArrowDown, FiBarChart2, FiCalendar, FiLogOut, FiShield, FiExternalLink, FiActivity, FiClock, FiSettings } from 'react-icons/fi';
import { resolvePortfolioUrl } from '../services/siteHost';
import './Sidebar.css';

function Sidebar({ currentPage, setCurrentPage, usuario, isAdmin, onLogout, onViewSite }) {
  const [isResolvingSite, setIsResolvingSite] = useState(false);

  const handleOpenSite = async () => {
    if (onViewSite) {
      onViewSite();
      return;
    }

    if (isResolvingSite) return;
    setIsResolvingSite(true);
    try {
      const portfolioUrl = await resolvePortfolioUrl();
      if (portfolioUrl) {
        window.location.href = portfolioUrl;
      } else {
        window.location.href = '/';
      }
    } catch (_) {
      window.location.href = '/';
    } finally {
      setIsResolvingSite(false);
    }
  };
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: FiHome },
    { id: 'agenda', label: 'Agenda', icon: FiCalendar },
    { id: 'clientes', label: 'Clientes', icon: FiUsers },
    { id: 'servicos', label: 'Serviços', icon: FiTool },
    { id: 'receita', label: 'Receitas', icon: FiArrowUp },
    { id: 'despesa', label: 'Despesas', icon: FiArrowDown },
    { id: 'crm', label: 'CRM Clientes', icon: FiActivity },
    { id: 'relatorios', label: 'Relatórios', icon: FiBarChart2 },
    { id: 'configuracoes', label: 'Configurações', icon: FiSettings },
    { id: 'logs', label: 'Auditoria / Logs', icon: FiClock },
  ];

  return (
    <aside className="sidebar">
      <div className="logo">
        <h1>✨ ERP Fran Beauty</h1>
      </div>
      <nav className="nav-menu">
        {menuItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <button
              key={item.id}
              className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => setCurrentPage(item.id)}
            >
              <IconComponent size={20} />
              <span>{item.label}</span>
            </button>
          );
        })}
        {isAdmin && (
          <button
            className={`nav-item nav-item-admin ${currentPage === 'usuarios' ? 'active' : ''}`}
            onClick={() => setCurrentPage('usuarios')}
          >
            <FiShield size={20} />
            <span>Usuários</span>
          </button>
        )}
      </nav>
      <div className="sidebar-footer">
        {usuario && (
          <div className="sidebar-user">
            <span className="sidebar-user-icon">👤</span>
            <span className="sidebar-user-name">{usuario}</span>
          </div>
        )}
        <button
          className="site-btn"
          onClick={handleOpenSite}
          title="Voltar ao site"
          type="button"
          disabled={isResolvingSite}
          aria-busy={isResolvingSite}
        >
          <FiExternalLink size={18} />
          <span>{isResolvingSite ? 'Abrindo...' : 'Voltar ao Site'}</span>
        </button>
        <button className="logout-btn" onClick={onLogout} title="Sair">
          <FiLogOut size={18} />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;

